export const ACTION_RESET = 'FETCH_YDC_ABOUT_RESET';
export const ACTION_REQUEST = 'FETCH_YDC_ABOUT_REQUEST';
export const ACTION_SUCCESS = 'FETCH_YDC_ABOUT_SUCCESS';
export const ACTION_ERROR = 'FETCH_YDC_ABOUT_ERROR';
